namespace Cfnc {
    "use strict";

    interface ICampusSearchLeftScope extends ng.IScope {
        vm: CampusSearchLeft;
    }

    interface ICampusSearchLeft {

    }

    export class Type { type: string; isChecked: boolean }


    class CampusSearchLeft implements ICampusSearchLeft {
        static controllerId: string = "campusSearchLeftCtrl";
        intervalPromise: angular.IPromise<any>;
        static $inject: Array<string> = ["campusSearchDataService", "savedSearchService", "common", "config", "$scope", "$uibModal", "Restangular", "$timeout", "$routeParams", "$window", "$location", "$rootScope", "sportList", "$interval", "$anchorScroll"];
        private log;

        institutions: Array<any>;
        //For Radios
        entranceDifficulty: string;
        actScores: string;
        rotcSelected: boolean;

        schools: Array<any>;
        markers: Array<any>;
        publicPrivates: PublicPrivates;
        publicPrivatesSelected: boolean;

        private savedSearchName: string;
        private savedSearch: any;
        private savedSearches: Array<any>;

        pinColors = { "UNC": "blue", "Independent": "red", "CommunityCollege": "yellow", "default": "black" };

        campusSearchForm: any;
        master: any;
        formFilters: any;
        filterOptions: IAvailableFilters;
        selectedFilters: Array<IAvaliableFiltersGroup>;
        filters: Array<IFilterPills>;
        nameFilter: Array<IAvaliableFiltersGroup>;
        selectedSchool: any;
        textToSearch: string;
        sortField: string;
        sortDesc: boolean;

        map: googleMaps.googleMap;
        options;
        stateCoords;
        mappingData;
        totalInstitutions: number;
        totalPages: number;
        currentPage: number;
        sortBy: string;

        filterCategories: any;

        hasSavedSearches: boolean;
        noSchoolData: boolean;

        filterText: string;
        savedFilters: any;
        searchName: string;

        privateChecked: boolean;
        dateTimeStart: any;
        currentEventDate: any;
        timeSpent: any;

        view: string = 'card';

        selectedSavedSearch: any;
        loading: boolean;

        name: string;
        pageSize: number = 10;

        filterMap: ICollegeSearchFilterMap;
        pills: ICollegeSearchFilterMap;

        apiHost: string;
        occCode: string;
        occTitle: string;

        institutionNames: string[];

        constructor(private campusSearchDataService: ICampusSearchDataService, private savedSearchService: IsavedSearchService, private common: ICommonFactory,
            private config: IConfig,
            private $scope: ICampusSearchLeftScope, private $uibModal: ng.ui.bootstrap.IModalService, private Restangular: Restangular.IService,
            private $timeout: ng.ITimeoutService, private $routeParams, private $window: ng.IWindowService, private $location: ng.ILocationService,
            private $rootScope: ng.IRootScopeService, private sportList: ISportList, private $interval: angular.IIntervalService, private $anchorScroll: ng.IAnchorScrollService) {

            this.log = this.common.logger.getLogFn(CampusSearchLeft.controllerId);
            this.institutions = [];
            this.markers = [];
            this.schools = [];
            this.sortField = "name";
            this.sortDesc = false;
            this.sortBy = "Name";
            this.currentPage = 1;
            this.dateTimeStart = performance.now();
            this.timeSpent = 0;
            this.intervalPromise = this.$interval(this.resetTimer, 30000);


            this.savedSearchName = $routeParams["savedSearchName"];

            this.noSchoolData = false;

            this.savedSearches = [];

            this.map = { pan: true, center: { latitude: 35.250224, longitude: -79.905000 }, zoom: 7, options: { streetViewControl: false, zoomControlOptions: { style: google.maps.ZoomControlStyle.SMALL } } };
            this.options = { options: { mapTypeId: google.maps.MapTypeId.TERRAIN, streetViewControl: false, zoomControlOptions: { style: google.maps.ZoomControlStyle.SMALL } } };
            this.stateCoords = coords;

            $rootScope.$on("$routeChangeStart",
                (event, next, current): void => {
                    this.$interval.cancel(this.intervalPromise);
                    appInsights.trackMetric("CampusSearchUseTime", this.timeSpent);
                }
            );

            this.filterOptions = campusSearchDataService.filterDefinition;
            this.selectedFilters = [];
            this.nameFilter = [];

            this.filterMap = this.getFilterMap();

            if (this.$location.state()) {
                this.getState(false);
            }
            else {
                this.selectedFilters = [];
                this.selectedFilters.push({ key: this.filterMap.state.national.group, filters: [{ key: this.filterMap.state.national.key }] } as IAvaliableFiltersGroup);
            }

            
            if (localStorage.getItem("collegeSearch.selectedFilters")) {
                this.selectedFilters = JSON.parse(localStorage.getItem("collegeSearch.selectedFilters"));
                this.applySelectedFiltersToMap();
                this.Save();
            }

            if (localStorage.getItem("collegeSearch.saveCollege")) {
                if (_.startsWith(document.referrer, this.common.authentication.providerUrls.authority)) {
                    this.saveCollege(JSON.parse(localStorage.getItem("collegeSearch.saveCollege")));
                }
                else {
                    localStorage.removeItem("collegeSearch.saveCollege");
                }
            }

            this.occCode = this.$location.search().occCode;
            this.activate();
        }

        loadSearchFromCollegePlanning() {
            if (this.savedSearchName && typeof this.savedSearches != 'undefined' && this.savedSearches.length > 0) {
                this.savedSearches.forEach((search) => {
                    if (search.name == this.savedSearchName) {
                        this.savedSearch = search;
                        this.selectedFilters = JSON.parse(this.savedSearch.search);
                    }
                });
                this.savedSearchName = null;
                this.applyFilters();
            }
        }

        activate() {
            this.apiHost = new Config().apiHost;
            var promises = [];
            this.common.activateController(promises, CampusSearchLeft.controllerId).then(() => {
                if (!this.savedSearchName) {
                    this.nameFilter[0] = this.selectedFilters[0];
                }


                this.common.authentication.isLoggedIn().then(loggedIn => {
                    if (loggedIn) {
                        this.loadSavedSearches();
                        this.$rootScope.$on(this.config.events.logout, (event) => {
                            this.activate();
                        });
                    }
                    else {
                        this.$rootScope.$on(this.config.events.login, (event, user: any) => {
                            this.activate();
                        });
                    }

                    this.log("Activated CampusSearch View ");
                    appInsights.trackEvent("CampusSearchLoaded");

                    if (this.occCode) {
                        this.search();
                        this.Restangular.all("careers").one("occupations").get({ occCode: this.occCode }).then((result: IOccupation) => {
                            this.occTitle = result.occTitle;
                        });
                    }
                    else {
                        this.applyFilters();
                    }
                })
            });
        }

        updateTimer() {
            this.$interval.cancel(this.intervalPromise);
            this.currentEventDate = performance.now();
            var diff = this.currentEventDate - this.dateTimeStart;
            this.timeSpent = this.timeSpent + diff;
            console.log(this.timeSpent);
            this.dateTimeStart = performance.now();
            this.intervalPromise = this.$interval(this.resetTimer, 30000);
        }

        resetTimer = () => {
            this.dateTimeStart = performance.now();
            console.log("timer reset.");
        }

        sortTable(sortBy: string, sortField: string) {
            if (this.sortBy === sortBy) {
                this.sortDesc = !this.sortDesc;
            }
            else {
                this.sortDesc = false;
                this.sortField = sortField;
                this.sortBy = sortBy;
            }

            this.currentPage = 1;
            this.search(1, this.pageSize, this.sortBy, this.sortDesc);
        }

        pageTable() {
            this.search(this.currentPage, this.pageSize, this.sortBy, this.sortDesc);
        }

        getInstitutionNames(viewValue) {
            return this.Restangular.one("campussearch").one("institutionNames").get({ search: viewValue, limit: 10, national: this.filterMap.state.national.model });

        }

        public search(page: number = 1, pageSize: number = this.pageSize, sortBy: string = "Name", sortDesc: boolean = false) {
            this.loading = true;
            this.$anchorScroll("results");
            this.currentPage = page;
            var cachedpageNumber = sessionStorage.getItem("currentPage");
            if (cachedpageNumber) {
                this.currentPage = +cachedpageNumber;
                page = this.currentPage;
                sessionStorage.removeItem("currentPage");
            }
            if (_.isEqual(this.selectedFilters, this.savedFilters)) {
                this.filterText = "Saved Search: " + this.searchName;
            }
            else {
                if (this.searchName != null && this.searchName != "") {
                    this.searchName = null;
                    this.savedFilters = null;
                }
                this.filterText = "Selected Filters: ";
            }

            this.savedSearchName = this.savedSearchService.getName() ? this.savedSearchService.getName() : null;
            this.savedSearchService.setName("");
            if (this.savedSearchName) {
                this.loadSavedSearches();
            } else {
                this.campusSearchDataService.getInstitutionsByFilter(this.selectedFilters, page, pageSize, sortBy, sortDesc, this.occCode).then((result) => {
                    if (result != null) {
                        this.institutions = result.results;
                        this.totalInstitutions = result.totalItems;
                        this.totalPages = result.totalItems / pageSize;
                        this.createMarkers(this.institutions);
                    }
                    else {

                        this.institutions = [];
                        this.noSchoolData = true;
                    }
                }, (reason) => {
                    this.log(reason);
                }).finally(() => {
                    this.loading = false;
                });
            }

            this.saveState();
        }

        saveState() {
            var state = {
                view: this.view,
                currentPage: this.currentPage,
                filterMap: JSON.stringify(this.filterMap),
                occCode: this.occCode
            }

            if (!_.isEqual(state, this.$location.state())) {
                return this.$location.state(state);
            }

        }

        getState(executeSearch?: boolean) {
            var state = this.$location.state();
            executeSearch = executeSearch === false ? false : !_.isEqual(state.selectedFilters, JSON.stringify(this.selectedFilters))
                || state.currentPage != this.currentPage;

            this.view = state.view && state.view != "null" ? state.view : 'card';
            this.currentPage = state.currentPage;
            var filterMapFromState = JSON.parse(state.filterMap);
            this.filterMap = _.merge(filterMapFromState, this.filterMap);
            this.occCode = this.occCode;

            if (executeSearch) {
                if (this.occCode) {
                    this.search();
                    this.Restangular.all("careers").one("occupations").get({ occCode: this.occCode }).then((result: IOccupation) => {
                        this.occTitle = result.occTitle;
                    });
                }
                else {
                    this.applyFilters(this.currentPage);
                }
            }
        }

        saveCollege(institution: IInstitution) {
            localStorage.setItem("collegeSearch.saveCollege", JSON.stringify(institution));
            this.common.authentication.authenticate(true).then(result => {
                if (result) {
                    if (!institution.isSaved) {
                        var modalInstance = this.$uibModal.open({
                            templateUrl: '/app/common/confirmationModal.html',
                            controller: 'confirmationModal',
                            resolve: {
                                data: {
                                    title: "Save College",
                                    content: "Are you sure you want to add " + institution.name + " to your list of Saved Colleges?"
                                }
                            }
                        });

                        modalInstance.result.then((result) => {
                            if (result) {
                                //this.cacheSavedCollege(institution);
                                this.Restangular.one("collegePlanning").post(institution.crossRoadsOrganizationId)
                                    .then((result: any) => {
                                        institution.isSaved = true;
                                        console.log(result);
                                    }, (reason) => {
                                        console.log(reason);
                                    });

                            }
                        }).finally(() => {
                            localStorage.removeItem("collegeSearch.saveCollege");
                        });
                    }
                    else {
                        var modalInstance = this.$uibModal.open({
                            templateUrl: '/app/common/confirmationModal.html',
                            size: 'sm',
                            controller: 'confirmationModal',
                            resolve: {
                                data: {
                                    title: "Remove Saved College",
                                    content: `Are you sure you wish to remove ${institution.name} from your saved colleges?`
                                }
                            }
                        });
                        modalInstance.result.then((val: boolean) => {
                            if (val) {
                                this.Restangular.all("collegePlanning/deletesavedcollege").post({ id: institution.id, organizationId: institution.crossRoadsOrganizationId }).then((results) => {
                                    console.log(results);
                                    institution.isSaved = false;
                                    //this.logSuccess("Your saved college changes have been saved", null, true);
                                }, (reason) => {
                                    console.error(reason);
                                });
                            }
                        }).finally(() => {
                            localStorage.removeItem("collegeSearch.saveCollege");
                        });
                    }
                }

            });

        }

        deleteSavedCollege = (institution: IInstitution) => {
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/collegePlanning/ConfirmModal.html',
                size: 'sm',
                controller: 'ConfirmModal',
            });
            modalInstance.result.then((val: boolean) => {
                if (val) {
                    this.Restangular.all("collegePlanning/deletesavedcollege").post({ id: institution.id, organizationId: institution.crossRoadsOrganizationId }).then((results) => {
                        console.log(results);
                        institution.isSaved = false;
                        //this.logSuccess("Your saved college changes have been saved", null, true);
                    }, (reason) => {
                        console.error(reason);
                    });
                }
            });
        }

        isCollegeSaved(institution: any) {
            this.Restangular.one("collegePlanning/issaved", institution.crossRoadsOrganizationId).get()
                .then((result: boolean) => {
                    institution.isSaved = result;
                }, (reason) => {
                    console.log(reason);
                });

        }

        redirectToSchool() {
            window.open("/index.html#/institutions/" + this.selectedSchool.id + "/campusprofile");
        }

        redirectToSelected() {
            var index = _.findIndex(this.schools, (x: any) => { return x.id === this.selectedSchool.id });
            if (index > -1)
                this.redirectToSchool();
        }

        private loadSavedSearches() {
            this.common.authentication.authenticate(true).then(result => {
                if (result) {
                    this.campusSearchDataService.loadSavedSearches().then((results) => {
                        this.savedSearches = results;
                        if (this.savedSearchName != null)
                            this.loadSearchFromCollegePlanning();
                    }, (reason) => {
                        this.log(reason);
                    });
                }
            });

        }


        private createMarkers(institutions: Array<any>) {
            this.markers = [];
            for (var i in institutions) {
                this.markers.push(this.setUpMarker(institutions[i]));

            }
        }

        private setUpMarker(institution: any) {
            var color = this.pinColors[institution.collegeType] || this.pinColors.default;
            console.log(document.location.origin + "/images/" + color + "_pin.png");
            var marker = {
                selected: false,
                latitude: institution.latitude,
                longitude: institution.longitude,
                id: institution.id,
                options: {
                    optimized: false,
                    title: institution.name,
                    icon: document.location.origin + "/images/" + color + "_pin.png"

                },
                show: false,
                onClick: () => {
                    if (institution.crossRoadsOrganizationId) {
                        this.$rootScope.$apply(() => {
                            this.redirectToCollegePage(institution);
                        });
                    }
                    else
                        this.$window.open(institution.website);
                }
            };

            return marker;
        }

        redirectToCollegePage(institution: IInstitution) {
            this.$location.path(`/college-profile/${institution.urlName}`);
        }

        OpenFiltersModal(subCat: string) {

            var modalInstance;

            switch (subCat) {
                case "PrivateReligious":
                    if (this.filterMap.publicPrivate.religious.model) {
                        modalInstance = this.$uibModal.open({
                            templateUrl: "/app/campusSearch/modals/publicPrivateModal.html",
                            controller: "publicPrivateModalCtrl",
                            controllerAs: "vm",
                            size: 'lg',
                            resolve: {
                                selectedFilters: () => [],
                                religions: () => this.filterOptions.keyFacts.religions
                            }
                        });

                        modalInstance.result.then((result: IAvaliableFiltersGroup[]) => {
                            //this.filterMap.religions.selectedReligions = result;

                            for (var religion in this.filterMap.religions) {
                                if (this.filterMap.religions[religion].model) {
                                    this.filterMap.religions[religion].model = null;
                                }
                            }

                            result[0].filters.forEach((r: any) => {
                                this.filterMap.religions[r.key.toLowerCase()].model = true;
                            })
                        });
                    }
                    else {
                        for (var religion in this.filterMap.religions) {
                            if (this.filterMap.religions[religion].model) {
                                this.filterMap.religions[religion].model = null;
                            }
                        }
                    }



                    break;

                case "Sports":

                    modalInstance = this.$uibModal.open({
                        templateUrl: "/app/campusSearch/modals/sportsModal.html",
                        controller: "sportsModalCtrl",
                        controllerAs: "vm",
                        size: "lg",
                        resolve: {
                            selectedFilters: () => _.cloneDeep(this.filterMap.sports.selectedSports),
                            collegeSports: () => this.filterOptions.interCollegiateSports
                        }
                    });

                    modalInstance.result.then((result: IAvaliableFiltersGroup[]) => {
                        this.filterMap.sports.selectedSports = result;

                        for (var sport in this.filterMap.sports) {
                            if (this.filterMap.sports[sport].model) {
                                this.filterMap.sports[sport].model = null;
                            }
                        }

                        result.forEach(r => {
                            var sport: any = _.find(r.filters, { key: "Sport" });
                            this.filterMap.sports[sport.value.toLowerCase()].model = true;
                        })
                    })
                    break;

                case "Majors":

                    var selectedMajors = [{ key: "ProgramsMajors", filters: [] }];
                    for (var major in this.filterMap.majors) {
                        if (this.filterMap.majors[major].model == true) {
                            selectedMajors[0].filters.push({
                                key: this.filterMap.majors[major].key,
                                value: this.filterMap.majors[major].value
                            });
                        }
                    }

                    modalInstance = this.$uibModal.open({
                        templateUrl: "/app/campusSearch/modals/majorsModal.html",
                        controller: "majorsModalCtrl",
                        controllerAs: "vm",
                        size: "lg",
                        resolve: {
                            selectedFilters: () => _.cloneDeep(selectedMajors),
                            majorsGroup: () => this.filterOptions.academics.programsMajors,
                            majorFilter: () => this.filterOptions.academics.major
                        }
                    });

                    modalInstance.result.then((result: IAvaliableFiltersGroup[]) => {
                        for (var major in this.filterMap.majors) {
                            if (this.filterMap.majors[major].model) {
                                this.filterMap.majors[major].model = null;
                            }

                            if (major.indexOf("_") == 0) {
                                delete this.filterMap.majors[major];
                            }
                        }

                        if (result.length > 0) {
                            result[0].filters.forEach(r => {
                                if (_.has(this.filterMap.majors, r.key.toLowerCase())) {
                                    this.filterMap.majors[r.key.toLowerCase()].model = true;

                                }
                                else {
                                    var majorFilter: ICollegeSearchFilter = {
                                        key: "MajorName",
                                        value: r.value.toString(),
                                        group: "Major",
                                        name: r.pillText,
                                        showInFilterList: true,
                                        model: true
                                    }

                                    this.filterMap.majors[r.key.toLowerCase()] = majorFilter;
                                }
                            })
                        }
                    });

                    break;
            }

        }

        showTipsModal() {
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/campusSearch/modals/tipsModal.html',
                controller: 'tipsModalCtrl'
            });
        }

        Clear() {

            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/campusSearch/modals/clearModal.html',
                controller: 'clearModalCtrl'
            });

            modalInstance.result.then((clearFilters: boolean) => {
                this.campusSearchForm = {};
                this.rotcSelected = false;
                this.filterText = "Selected Filters:";
                this.selectedSavedSearch = null;
                this.filterMap = this.getFilterMap();
                this.selectedFilters = [];
                this.selectedFilters.push({ key: this.filterMap.state.national.group, filters: [{ key: this.filterMap.state.national.key }] } as IAvaliableFiltersGroup);
                this.currentPage = 1;
                this.occCode = null;
                this.occTitle = null;
                this.$location.search("occCode", null);
                this.applyFilters();
            });

        }

        Save() {
            localStorage.setItem("collegeSearch.selectedFilters", JSON.stringify(this.selectedFilters));
            this.common.authentication.authenticate(true).then(result => {
                if (result) {
                    var modalInstance = this.$uibModal.open({
                        templateUrl: '/app/campusSearch/modals/saveSearchModal.html',
                        controller: 'saveSearchModalCtrl'
                    });

                    modalInstance.result.then((savedSearchName: string) => {
                        var search = new SavedSearch(savedSearchName, JSON.parse(localStorage.getItem("collegeSearch.selectedFilters")));
                        this.campusSearchDataService.saveCampusSearch(search)
                            .then(() => {
                                this.loadSavedSearches();
                            });
                    }).finally(() => {
                        localStorage.removeItem("collegeSearch.selectedFilters");
                    });
                }
            });

        }

        selectSearch() {
            this.selectedFilters = [];
            this.selectedFilters = JSON.parse(this.selectedSavedSearch.search);
            this.applySelectedFiltersToMap();
            this.filterText = "Saved Search: " + this.selectedSavedSearch.searchName;
            this.searchName = this.selectedSavedSearch.searchName;
            this.savedFilters = _.cloneDeep(this.selectedFilters);
            this.applyFilters();
        }

        setView(view: string) {
            this.view = view;
            this.saveState().replace();

        }

        applySelectedFiltersToMap() {
            var stateSelected = false;
            this.filterMap = this.getFilterMap();
            this.selectedFilters.forEach((group) => {
                if (group.key.indexOf("Sports") == 0) {
                    this.filterMap.sports.selectedSports.push(group);
                }
                else {
                    group.filters.forEach((filter) => {
                        if (filter.key == "State") {
                            stateSelected = true;
                        }

                        if (filter.key == "MajorName") {
                            this.filterMap.majors[filter.key] = {
                                key: "MajorName",
                                value: filter.value,
                                group: "Major",
                                name: `Major: ${filter.value}`,
                                showInFilterList: true,
                                model: true
                            };
                        }

                        _.forOwn(this.filterMap, (fmGroup) => {
                            _.forOwn(fmGroup, (fmFilter: ICollegeSearchFilter) => {
                                if (fmFilter.key == filter.key) {
                                    fmFilter.model = filter.value || (filter.key == "State" ? false : true);
                                    if (fmFilter.key == this.filterMap.distance.withinRangeOf.key) {
                                        this.filterMap.distance.range.model = (filter.value as string).split(",")[0] || null;
                                        this.filterMap.distance.zipCode.model = (filter.value as string).split(",")[1] || null;
                                    }
                                }
                            })
                        });
                    });
                }

                this.filterMap.sports.selectedSports.forEach(r => {
                    var sport: any = _.find(r.filters, { key: "Sport" });
                    this.filterMap.sports[sport.value.toLowerCase()].model = true;
                })
            });

            this.filterMap.state.national.model = !stateSelected;
        }



        applyFilters(page: number = 1, pageSize: number = this.pageSize, sortBy: string = "Name", sortDesc: boolean = false) {
            //clear the occCode from the search. Currently can't search within results so we will remove the filter
            this.occCode = null;
            this.occTitle = null;
            this.$location.search("occCode", null);

            if (this.filterMap.state.national.model) {
                this.map = { center: { latitude: 38.103137, longitude: -98.169883 }, zoom: 4, pan: true };
            }
            else {
                this.map = { center: { latitude: 35.250224, longitude: -79.905000 }, zoom: 7, pan: true };
            }

            this.selectedFilters = [];
            this.selectedSavedSearch = null;

            if (this.$location.search().freeApp) {
                this.filterMap.applicationFee.applicationFee.model = "0";
                this.$location.search("freeApp", null);
                
            }

            if (this.filterMap.distance.range.model && this.filterMap.distance.zipCode.model) {
                this.filterMap.distance.withinRangeOf.value = `${this.filterMap.distance.range.model},${this.filterMap.distance.zipCode.model || ''}`;
                this.filterMap.distance.withinRangeOf.model = true;
            }
            else {
                this.filterMap.distance.withinRangeOf.model = false;
            }

            if (!this.filterMap.state.national.model) {
                this.selectedFilters.push({ key: "State", filters: [{ key: "State" }] });
            }

            _.forOwn(this.filterMap, (fmGroup) => {
                var group;
                _.forOwn(fmGroup, (fmFilter: ICollegeSearchFilter) => {
                    if (fmFilter && fmFilter.model && !fmFilter.ignore) {
                        var filter: any = {
                            key: fmFilter.key
                        }

                        if (typeof fmFilter.model != "boolean") {
                            filter.value = fmFilter.model;
                        }

                        if (fmFilter.value) {
                            filter.value = fmFilter.value;
                        }

                        if (group == null) {
                            group = {
                                key: fmFilter.group,
                                filters: []
                            };
                        }

                        group.filters.push(filter);
                    }
                    if (angular.isArray(fmFilter)) {
                        this.selectedFilters = this.selectedFilters.concat(fmFilter);
                    }
                });

                if (group && group.filters.length > 0) {
                    this.selectedFilters.push(group);
                }
            });

            this.search(page, pageSize, sortBy, sortDesc);
            this.pills = _.cloneDeep(this.filterMap);
        }


        removeFilter(filter) {
            filter.model = null;
            this.filterMap = this.pills;
            this.applyFilters();

        }

        removeSportsFilter(filter) {
            filter.model = null;
            this.filterMap = this.pills;

            this.filterMap.sports.selectedSports = _.remove(this.filterMap.sports.selectedSports, s => { return _.some(s, { key: filter.key }) });
            this.applyFilters();
        }


        getFilterMap(): ICollegeSearchFilterMap {
            return {
                name: {
                    name: {
                        key: "Name",
                        group: "Name",
                        name: "Name",
                        showInFilterList: false
                    }
                },
                schoolType: {
                    twoYear: {
                        key: "TwoYear",
                        group: "SchoolType",
                        name: "Two Year",
                        showInFilterList: true
                    },
                    fourYear: {
                        key: "FourYear",
                        group: "SchoolType",
                        name: "Four Year",
                        showInFilterList: true
                    },
                    graduate: {
                        key: "Graduate",
                        group: "SchoolType",
                        name: "Graduate",
                        showInFilterList: true
                    }
                },
                distance: {
                    range: {
                        key: "Range",
                        group: "Distance",
                        model: "50",
                        name: "Range",
                        ignore: true,
                        showInFilterList: false
                    },
                    zipCode: {
                        key: "ZipCode",
                        group: "Distance",
                        name: "Zip code",
                        ignore: true,
                        showInFilterList: false
                    },
                    withinRangeOf: {
                        key: "WithinRangeOf",
                        group: "WithinRangeOf",
                        name: "Distance",
                        showInFilterList: false
                    }
                },
                programType: {
                    certificate: {
                        key: "Certificate",
                        group: "ProgramType",
                        name: "Certificate",
                        showInFilterList: true
                    },
                    diploma: {
                        key: "Diploma",
                        group: "ProgramType",
                        name: "Diploma",
                        showInFilterList: true
                    },
                    associate: {
                        key: "Associate",
                        group: "ProgramType",
                        name: "Associate",
                        showInFilterList: true
                    },
                    bachelors: {
                        key: "Bachelors",
                        group: "ProgramType",
                        name: "Bachelors",
                        showInFilterList: true
                    },
                    masters: {
                        key: "Masters",
                        group: "ProgramType",
                        name: "Masters",
                        showInFilterList: true
                    },
                    doctoral: {
                        key: "Doctoral",
                        group: "ProgramType",
                        name: "Doctoral",
                        showInFilterList: true
                    }
                },
                studentPopulation: {
                    xs: {
                        key: "XS",
                        group: "StudentPopulation",
                        value: "1,2500",
                        name: "Less than 2,500",
                        showInFilterList: true
                    },
                    s: {
                        key: "S",
                        group: "StudentPopulation",
                        value: "2501,5000",
                        name: "2,501 - 5,000",
                        showInFilterList: true
                    },
                    m: {
                        key: "M",
                        group: "StudentPopulation",
                        value: "5001,10000",
                        name: "5,001 - 10,000",
                        showInFilterList: true
                    },
                    l: {
                        key: "L",
                        group: "StudentPopulation",
                        value: "10001,15000",
                        name: "10,001 - 15,000",
                        showInFilterList: true
                    },
                    xl: {
                        key: "XL",
                        group: "StudentPopulation",
                        value: "15001,20000",
                        name: "15,001 - 20,000",
                        showInFilterList: true
                    },
                    xxl: {
                        key: "XXL",
                        group: "StudentPopulation",
                        value: "20001",
                        name: "Greater than 20,000",
                        showInFilterList: true
                    }
                },
                campusSetting: {
                    urban: {
                        key: "Urban",
                        group: "CampusSetting",
                        name: "Urban",
                        showInFilterList: true
                    },
                    suburban: {
                        key: "Suburban",
                        group: "CampusSetting",
                        name: "Suburban",
                        showInFilterList: true
                    },
                    smallTown: {
                        key: "SmallTown",
                        group: "CampusSetting",
                        name: "Small town",
                        showInFilterList: true
                    },
                    rural: {
                        key: "Rural",
                        group: "CampusSetting",
                        name: "Rural",
                        showInFilterList: true
                    }
                },
                publicPrivate: {
                    public: {
                        key: "Public",
                        group: "PublicPrivate",
                        name: "Public",
                        showInFilterList: true
                    },
                    private: {
                        key: "Private",
                        group: "PublicPrivate",
                        name: "Private",
                        ignore: true,
                        showInFilterList: false
                    },
                    religious: {
                        key: "PrivateReligious",
                        group: "PublicPrivate",
                        name: "Private/Religious",
                        showInFilterList: true
                    },
                    nonReligious: {
                        key: "Private",
                        group: "PublicPrivate",
                        name: "Private/Non-Religious",
                        showInFilterList: true
                    }
                },
                religions: {
                    religion: {
                        key: "Religions",
                        group: "Religions",
                        name: "Religions",
                        showInFilterList: true
                    },
                    adventist: {
                        key: "Adventist", group: "Religions", name: "Adventist",
                        showInFilterList: true
                    },
                    africanmethodistepiscopal: {
                        key: "AfricanMethodistEpiscopal", group: "Religions", name: "African Methodist-Episcopal",
                        showInFilterList: true
                    },
                    assemblyofgod: {
                        key: "AssemblyofGod", group: "Religions", name: "Assembly of God",
                        showInFilterList: true
                    },
                    baptist: {
                        key: "Baptist", group: "Religions", name: "Baptist",
                        showInFilterList: true
                    },
                    christianmissionaryalliance: {
                        key: "ChristianMissionaryAlliance", group: "Religions", name: "Christian & Missionary Alliance",
                        showInFilterList: true
                    },
                    christianscience: {
                        key: "ChristianScience", group: "Religions", name: "Christian Science",
                        showInFilterList: true
                    },
                    churchofchrist: {
                        key: "ChurchofChrist", group: "Religions", name: "Church of Christ",
                        showInFilterList: true
                    },
                    churchofgod: {
                        key: "ChurchofGod", group: "Religions", name: "Church of God",
                        showInFilterList: true
                    },
                    churchofthebrethren: {
                        key: "ChurchoftheBrethren", group: "Religions", name: "Church of the Brethren",
                        showInFilterList: true
                    },
                    congregational: {
                        key: "Congregational", group: "Religions", name: "Congregational (United Church of Christ)",
                        showInFilterList: true
                    },
                    disciplesofchrist: {
                        key: "DisciplesofChrist", group: "Religions", name: "Disciples of Christ",
                        showInFilterList: true
                    },
                    episcopal: {
                        key: "Episcopal", group: "Religions", name: "Episcopal (Anglican)",
                        showInFilterList: true
                    },
                    evangelical: {
                        key: "Evangelical", group: "Religions", name: "Evangelical",
                        showInFilterList: true
                    },
                    islamic: {
                        key: "Islamic", group: "Religions", name: "Islamic",
                        showInFilterList: true
                    },
                    interdenominational: {
                        key: "Interdenominational", group: "Religions", name: "Interdenominational Christian",
                        showInFilterList: true
                    },
                    jewish: {
                        key: "Jewish", group: "Religions", name: "Jewish",
                        showInFilterList: true
                    },
                    lutheran: {
                        key: "Lutheran", group: "Religions", name: "Lutheran",
                        showInFilterList: true
                    },
                    mennonite: {
                        key: "Mennonite", group: "Religions", name: "Mennonite",
                        showInFilterList: true
                    },
                    methodist: {
                        key: "Methodist", group: "Religions", name: "Methodist",
                        showInFilterList: true
                    },
                    moravian: {
                        key: "Moravian", group: "Religions", name: "Moravian",
                        showInFilterList: true
                    },
                    mormon: {
                        key: "Mormon", group: "Religions", name: "Mormon",
                        showInFilterList: true
                    },
                    nondenominational: {
                        key: "Nondenominational", group: "Religions", name: "Nondenominational Christian",
                        showInFilterList: true
                    },
                    other: {
                        key: "Other", group: "Religions", name: "Other",
                        showInFilterList: true
                    },
                    otherchristian: {
                        key: "OtherChristian", group: "Religions", name: "Other Christian",
                        showInFilterList: true
                    },
                    plymouthbrethren: {
                        key: "PlymouthBrethren", group: "Religions", name: "Plymouth Brethren",
                        showInFilterList: true
                    },
                    presbyterian: {
                        key: "Presbyterian", group: "Religions", name: "Presbyterian",
                        showInFilterList: true
                    },
                    quaker: {
                        key: "Quaker", group: "Religions", name: "Quaker(Society of Friends)",
                        showInFilterList: true
                    },
                    reformed: {
                        key: "Reformed", group: "Religions", name: "Reformed",
                        showInFilterList: true
                    },
                    catholic: {
                        key: "Catholic", group: "Religions", name: "Roman Catholic",
                        showInFilterList: true
                    },
                    wesleyan: {
                        key: "Wesleyan", group: "Religions", name: "Wesleyan",
                        showInFilterList: true
                    }
                },
                studentHousing: {
                    menOnly: {
                        key: "Menonly",
                        group: "StudentHousing",
                        name: "Men Only",
                        showInFilterList: true
                    },
                    womenOnly: {
                        key: "Womenonly",
                        group: "StudentHousing",
                        name: "Women Only",
                        showInFilterList: true
                    },
                    coedDorms: {
                        key: "CoedDorms",
                        group: "StudentHousing",
                        name: "Coed Dorms",
                        showInFilterList: true
                    },
                    coopHouse: {
                        key: "CoopHouse",
                        group: "StudentHousing",
                        name: "Coop Housing",
                        showInFilterList: true
                    },
                    greekHousing: {
                        key: "GreekHousing",
                        group: "StudentHousing",
                        name: "Fraternity/Sorority housing",
                        ignore: true,
                        showInFilterList: false
                    },
                    fraternity: {
                        key: "FraternityHousingAvailable",
                        group: "StudentHousing",
                        name: "Fraternity housing",
                        showInFilterList: true
                    },
                    sorority: {
                        key: "SororityHousingAvailable",
                        group: "StudentHousing",
                        name: "Sorority housing",
                        showInFilterList: true
                    },
                    special: {
                        key: "SpecialHousing",
                        group: "StudentHousing",
                        name: "Special Housing",
                        showInFilterList: true
                    }
                },
                onlineEducation: {
                    degreeCourses: {
                        key: "OnlineDegreeCourses",
                        group: "OnlineEducation",
                        name: "Some online degree programs",
                        showInFilterList: true
                    },
                    degreePrograms: {
                        key: "OnlineDegreePrograms",
                        group: "OnlineEducation",
                        name: "All programs available online",
                        showInFilterList: true
                    },
                    entirelyOnline: {
                        key: "EntirelyOnlineSchool",
                        group: "OnlineEducation",
                        name: "Entirely online school",
                        showInFilterList: true
                    }
                },
                gender: {
                    mens: {
                        key: "Mens",
                        group: "SingleSexOrCoed",
                        name: "Men's College",
                        showInFilterList: true
                    },
                    womens: {
                        key: "Womens",
                        group: "SingleSexOrCoed",
                        name: "Women's College",
                        showInFilterList: true
                    },
                    coed: {
                        key: "Coed",
                        group: "SingleSexOrCoed",
                        name: "Coed",
                        showInFilterList: true
                    }
                },
                tuition: {
                    inState: {
                        key: "InStateTuition",
                        group: "InStateTuition",
                        name: "In-state Tuition",
                        showInFilterList: true
                    },
                    outState: {
                        key: "OutStateTuition",
                        group: "OutStateTuition",
                        name: "Out-of-state Tuition",
                        showInFilterList: true
                    }
                },
                financialAid: {
                    academicScholarships: {
                        key: "AcademicScholarships",
                        group: "FinancialAid",
                        name: "Academic scholarships",
                        showInFilterList: true
                    },
                    athleticScholarships: {
                        key: "AthleticScholarships",
                        group: "FinancialAid",
                        name: "Athletic scholarships",
                        showInFilterList: true
                    },
                    federalWorkStudy: {
                        key: "FederalWorkStudy",
                        group: "FinancialAid",
                        name: "Federal work study",
                        showInFilterList: true
                    },
                    federalGrantsAndScholarships: {
                        key: "FederalGrantsAndScholarships",
                        group: "FinancialAid",
                        name: "Federal/State grants",
                        showInFilterList: true
                    },
                    stateGrantsAndScholarships: {
                        key: "StateGrantsAndScholarships",
                        group: "FinancialAid",
                        name: "Federal/state grants",
                        showInFilterList: false
                    },
                    institutionalGrants: {
                        key: "InstitutionalGrants",
                        group: "FinancialAid",
                        name: "Institutional grants",
                        showInFilterList: true

                    },
                    parentLoans: {
                        key: "ParentLoans",
                        group: "FinancialAid",
                        name: "Parent loans",
                        showInFilterList: true
                    }
                },
                specialPrograms: {
                    acceleratedStudy: {
                        key: "AcceleratedStudy",
                        group: "SpecialPrograms",
                        name: "Accelerated study",
                        showInFilterList: true
                    },
                    distanceLearning: {
                        key: "DistanceLearning",
                        group: "SpecialPrograms",
                        name: "Distance learning",
                        showInFilterList: true
                    },
                    doubleMajors: {
                        key: "DoubleMajors",
                        group: "SpecialPrograms",
                        name: "Double majors",
                        showInFilterList: true
                    },
                    honorsProgram: {
                        key: "HonorsProgram",
                        group: "SpecialPrograms",
                        name: "Honors program",
                        showInFilterList: true
                    },
                    independentStudy: {
                        key: "IndependentStudy",
                        group: "SpecialPrograms",
                        name: "Independent study",
                        showInFilterList: true
                    },
                    internships: {
                        key: "Internships",
                        group: "SpecialPrograms",
                        name: "Internships",
                        showInFilterList: true
                    },
                    selfDesignedMajors: {
                        key: "SelfdesignedMajors",
                        group: "SpecialPrograms",
                        name: "Self-designed majors",
                        showInFilterList: true
                    },
                    studyAbroad: {
                        key: "StudyAbroad",
                        group: "SpecialPrograms",
                        name: "Study abroad",
                        showInFilterList: true
                    }
                },
                studentFacultyRatio: {
                    ratio: {
                        key: "StudentFacultyRatio",
                        group: "StudentFacultyRatio",
                        name: "Student:Faculty",
                        showInFilterList: true
                    }
                },
                entranceDifficulty: {
                    difficulty: {
                        key: "EntranceDifficulty",
                        group: "EntranceDifficulty",
                        name: "Entrance difficulty",
                        showInFilterList: true
                    }
                },
                scores: {
                    act: {
                        key: "ActScores",
                        group: "ActScores",
                        name: "ACT scores",
                        showInFilterList: true
                    },
                    sat: {
                        key: "SatScores",
                        group: "SatScores",
                        name: "SAT scores",
                        showInFilterList: true
                    },
                    satReading: {
                        key: "SatReading",
                        group: "SatReading",
                        name: "SAT reading",
                        showInFilterList: true
                    },
                    satMath: {
                        key: "SatMath",
                        group: "SatMath",
                        name: "SAT math",
                        showInFilterList: true
                    },
                    satWriting: {
                        key: "SatWriting",
                        group: "SatWriting",
                        name: "SAT writing",
                        showInFilterList: true
                    }
                },
                admissionsPolicies: {
                    earlyAction: {
                        key: "EarlyAction",
                        group: "AdmissionsPolicies",
                        name: "Early action",
                        showInFilterList: true
                    },
                    earlyDecision: {
                        key: "EarlyDecision",
                        group: "AdmissionsPolicies",
                        name: "Early decision",
                        showInFilterList: true
                    },
                    deferredAdmission: {
                        key: "DeferredAdmission",
                        group: "AdmissionsPolicies",
                        name: "Deferred admission",
                        showInFilterList: true
                    },
                    concurrentEnrollment: {
                        key: "ConcurrentEnrollment",
                        group: "AdmissionsPolicies",
                        name: "Concurrent enrollment",
                        showInFilterList: true
                    }
                },
                historicallyBlack: {
                    historicallyBlack: {
                        key: "HistoricallyBlack",
                        group: "HistoricallyBlack",
                        name: "Historically black",
                        showInFilterList: true
                    }
                },
                sports: {
                    options: { ignore: true },
                    arch: { key: "ARCH", group: "Sports", name: "Archery", ignore: true, showInFilterList: false },
                    badmi: { key: "BADMI", group: "Sports", name: "Badminton", ignore: true, showInFilterList: false },
                    baseb: { key: "BASEB", group: "Sports", name: "Baseball", ignore: true, showInFilterList: false },
                    bsktb: { key: "BSKTB", group: "Sports", name: "Basketball", ignore: true, showInFilterList: false },
                    bicyc: { key: "BICYC", group: "Sports", name: "Bicycling", ignore: true, showInFilterList: false },
                    bowlg: { key: "BOWLG", group: "Sports", name: "Bowling", ignore: true, showInFilterList: false },
                    cheer: { key: "CHEER", group: "Sports", name: "Cheerleading", ignore: true, showInFilterList: false },
                    crew: { key: "CREW", group: "Sports", name: "Crew", ignore: true, showInFilterList: false },
                    xrun: { key: "XRUN", group: "Sports", name: "Cross-Country", ignore: true, showInFilterList: false },
                    eques: { key: "EQUES", group: "Sports", name: "Equestrian Sports", ignore: true, showInFilterList: false },
                    fence: { key: "FENCE", group: "Sports", name: "Fencing", ignore: true, showInFilterList: false },
                    fhock: { key: "FHOCK", group: "Sports", name: "Field Hockey", ignore: true, showInFilterList: false },
                    footb: { key: "FOOTB", group: "Sports", name: "Football", ignore: true, showInFilterList: false },
                    golf: { key: "GOLF", group: "Sports", name: "Golf", ignore: true, showInFilterList: false },
                    gymna: { key: "GYMNA", group: "Sports", name: "Gymnastics", ignore: true, showInFilterList: false },
                    hocke: { key: "HOCKE", group: "Sports", name: "Ice Hockey", ignore: true, showInFilterList: false },
                    lacro: { key: "LACRO", group: "Sports", name: "Lacrosse", ignore: true, showInFilterList: false },
                    racqu: { key: "RACQU", group: "Sports", name: "Racquetball", ignore: true, showInFilterList: false },
                    rifle: { key: "RIFLE", group: "Sports", name: "Riflery", ignore: true, showInFilterList: false },
                    rugby: { key: "RUGBY", group: "Sports", name: "Rugby", ignore: true, showInFilterList: false },
                    sailg: { key: "SAILG", group: "Sports", name: "Sailing", ignore: true, showInFilterList: false },
                    skiin: { key: "SKIIN", group: "Sports", name: "Skiing (downhill)", ignore: true, showInFilterList: false },
                    soccr: { key: "SOCCR", group: "Sports", name: "Soccer", ignore: true, showInFilterList: false },
                    softb: { key: "SOFTB", group: "Sports", name: "Softball", ignore: true, showInFilterList: false },
                    squas: { key: "SQUAS", group: "Sports", name: "Squash", ignore: true, showInFilterList: false },
                    stre3: { key: "STRE3", group: "Sports", name: "Strength & Conditioning", ignore: true, showInFilterList: false },
                    swim: { key: "SWIM", group: "Sports", name: "Swimming", ignore: true, showInFilterList: false },
                    tenni: { key: "TENNI", group: "Sports", name: "Tennis", ignore: true, showInFilterList: false },
                    track: { key: "TRACK", group: "Sports", name: "Track and Field", ignore: true, showInFilterList: false },
                    ultim: { key: "ULTIM", group: "Sports", name: "Ultimate Frisbee", ignore: true, showInFilterList: false },
                    vollb: { key: "VOLLB", group: "Sports", name: "Volleyball", ignore: true, showInFilterList: false },
                    wpolo: { key: "WPOLO", group: "Sports", name: "Water Polo", ignore: true, showInFilterList: false },
                    "00024": { key: "00024", group: "Sports", name: "Water Skiing", ignore: true, showInFilterList: false },
                    wlift: { key: "WLIFT", group: "Sports", name: "Weight Lifting", ignore: true, showInFilterList: false },
                    "00031": { key: "00031", group: "Sports", name: "Winter (Indoor) Track", ignore: true, showInFilterList: false },
                    wrest: { key: "WREST", group: "Sports", name: "Wrestling", ignore: true, showInFilterList: false },
                    selectedSports: []
                },
                state: {
                    national: {
                        key: "State",
                        group: "State",
                        name: "National",
                        ignore: true,
                        showInFilterList: true
                    }
                },
                majors: {
                    agriculturefoodandnaturalresources: { key: "AgricultureFoodandNaturalResources", group: "ProgramsMajors", name: "Agriculture, Food and Natural Resources", showInFilterList: true },
                    architectureandconstruction: { key: "ArchitectureAndConstruction", group: "ProgramsMajors", name: "Architecture and Construction", showInFilterList: true },
                    artsaudiovideotechnologyandcommunications: { key: "ArtsAudioVideoTechnologyAndCommunications", group: "ProgramsMajors", name: "Arts, Audio-Video Technology and Communications", showInFilterList: true },
                    businessmanagementadministration: { key: "BusinessManagementAdministration", group: "ProgramsMajors", name: "Business, Management and Administration", showInFilterList: true },
                    educationandtraining: { key: "EducationAndTraining", group: "ProgramsMajors", name: "Education and Training", showInFilterList: true },
                    finance: { key: "Finance", group: "ProgramsMajors", name: "Finance", showInFilterList: true },
                    governmentandpublicadministration: { key: "GovernmentAndPublicAdministration", group: "ProgramsMajors", name: "Government and Public Administration", showInFilterList: true },
                    healthscience: { key: "HealthScience", group: "ProgramsMajors", name: "Health Science", showInFilterList: true },
                    hospitalityandtourism: { key: "HospitalityAndTourism", group: "ProgramsMajors", name: "Hospitality and Tourism", showInFilterList: true },
                    humanservices: { key: "HumanServices", group: "ProgramsMajors", name: "Human Services", showInFilterList: true },
                    informationtechnology: { key: "InformationTechnology", group: "ProgramsMajors", name: "Information Technology", showInFilterList: true },
                    lawpublicsafetycorrectionssecurity: { key: "LawPublicSafetyCorrectionsSecurity", group: "ProgramsMajors", name: "Law, Public Safety, Corrections and Security", showInFilterList: true },
                    manufacturing: { key: "Manufacturing", group: "ProgramsMajors", name: "Manufacturing", showInFilterList: true },
                    marketing: { key: "Marketing", group: "ProgramsMajors", name: "Marketing", showInFilterList: true },
                    sciencetechengineeringmath: { key: "ScienceTechEngineeringMath", group: "ProgramsMajors", name: "Science, Technology, Engineering and Mathematics", showInFilterList: true },
                    transportationdistributionlogistics: { key: "TransportationDistributionLogistics", group: "ProgramsMajors", name: "Transportation, Distribution and Logistics", showInFilterList: true },
                },
                applicationFee: {
                    applicationFee: {
                        showInFilterList: true,
                        key: "ApplicationFee",
                        group: "ApplicationFee",
                        name: "Free App",
                        ignore: false
                    }
                }
            }
        }
    }

    angular.module("app").controller(CampusSearchLeft.controllerId, CampusSearchLeft);

    var coords = [{ latitude: 33.7963, longitude: -78.4850 },
    { latitude: 34.8037, longitude: -79.6742 },
    { latitude: 34.8206, longitude: -80.8003 },
    { latitude: 34.9377, longitude: -80.7880 },
    { latitude: 35.1019, longitude: -80.9377 },
    { latitude: 35.0356, longitude: -81.0379 },
    { latitude: 35.1457, longitude: -81.0324 },
    { latitude: 35.1660, longitude: -81.3867 },
    { latitude: 35.1985, longitude: -82.2739 },
    { latitude: 35.2041, longitude: -82.3933 },
    { latitude: 35.0637, longitude: -82.7765 },
    { latitude: 35.0817, longitude: -82.7861 },
    { latitude: 34.9996, longitude: -83.1075 },
    { latitude: 34.9918, longitude: -83.6183 },
    { latitude: 34.9918, longitude: -84.3201 },
    { latitude: 35.2131, longitude: -84.2885 },
    { latitude: 35.2680, longitude: -84.2226 },
    { latitude: 35.2310, longitude: -84.1113 },
    { latitude: 35.2815, longitude: -84.0454 },
    { latitude: 35.4058, longitude: -84.0248 },
    { latitude: 35.4719, longitude: -83.9424 },
    { latitude: 35.5166, longitude: -83.8559 },
    { latitude: 35.5512, longitude: -83.6938 },
    { latitude: 35.5680, longitude: -83.5181 },
    { latitude: 35.6327, longitude: -83.3849 },
    { latitude: 35.7142, longitude: -83.2475 },
    { latitude: 35.7799, longitude: -82.9962 },
    { latitude: 35.8445, longitude: -82.9276 },
    { latitude: 35.9224, longitude: -82.8191 },
    { latitude: 35.9958, longitude: -82.7710 },
    { latitude: 36.0613, longitude: -82.6419 },
    { latitude: 35.9702, longitude: -82.6103 },
    { latitude: 35.9547, longitude: -82.5677 },
    { latitude: 36.0236, longitude: -82.4730 },
    { latitude: 36.0669, longitude: -82.4194 },
    { latitude: 36.1168, longitude: -82.3535 },
    { latitude: 36.1345, longitude: -82.2862 },
    { latitude: 36.1467, longitude: -82.1461 },
    { latitude: 36.1035, longitude: -82.1228 },
    { latitude: 36.1268, longitude: -82.0267 },
    { latitude: 36.2797, longitude: -81.9360 },
    { latitude: 36.3527, longitude: -81.7987 },
    { latitude: 36.3361, longitude: -81.7081 },
    { latitude: 36.5880, longitude: -81.6724 },
    { latitude: 36.5659, longitude: -80.7234 },
    { latitude: 36.5438, longitude: -80.2977 },
    { latitude: 36.5449, longitude: -79.6729 },
    { latitude: 36.5449, longitude: -77.2559 },
    { latitude: 36.5505, longitude: -75.7562 },
    { latitude: 36.3129, longitude: -75.7068 },
    { latitude: 35.7131, longitude: -75.4129 },
    { latitude: 35.2041, longitude: -75.4720 },
    { latitude: 34.9794, longitude: -76.0748 },
    { latitude: 34.5258, longitude: -76.4951 },
    { latitude: 34.5880, longitude: -76.8109 },
    { latitude: 34.5314, longitude: -77.1378 },
    { latitude: 34.3910, longitude: -77.4481 },
    { latitude: 34.0481, longitude: -77.7983 },
    { latitude: 33.7666, longitude: -77.9260 },
    { latitude: 33.7963, longitude: -78.4863 }];



}